<section class="d-flex justify-content-between mt-2 w-100">
    <section class="btn-toolbar">
        <p class="ms-2">Periode: </p>
        <app-date-picker-dk
            class="ms-2"
            id="fra"
            #fraPicker="ngModel"
            name="fra"
            [maxDate]="tilPicker.value | ngbDateStruct"
            (ngModelChange)="onFraChange($event, fraPicker.valid)"
            [ngModel]="periode?.fra"></app-date-picker-dk>

        <app-date-picker-dk
            class="ms-2"
            id="til"
            #tilPicker="ngModel"
            name="til"
            [endOfDay]="true"
            [minDate]="fraPicker.value | ngbDateStruct"
            (ngModelChange)="onTilChange($event, tilPicker.valid)"
            [ngModel]="periode?.til"></app-date-picker-dk>

        <div class="ms-2">
            <p>Antal år: </p>
        </div>

        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary btn-sm btn--menu ms-2" id="select" ngbDropdownToggle>{{ selectedYear }}</button>
            <div ngbDropdownMenu aria-labelledby="select">
                <button class="dropdown-item" (click)="onSelectYear(1)">1</button>
                <button class="dropdown-item" (click)="onSelectYear(2)">2</button>
                <button class="dropdown-item" (click)="onSelectYear(3)">3</button>
            </div>
        </div>
    </section>
</section>
